export class WoundsDressingContext {
  private static allowEdit: boolean;

  public static setAllowEdit(allow: boolean): void {
    this.allowEdit = allow;
  }

  public static getAllowEdit(): boolean {
    return this.allowEdit;
  }
}
